export default "__VITE_ASSET__BEfxDSu9__"